export default "__VITE_ASSET__q39XrNal__"